import React from 'react';
import {
  ProfessionalNetworkLinkedin,
  SocialMediaFacebook,
  SocialMediaTwitter,
  SocialVideoYoutube,
  SocialMediaInstagram,
} from '@hbf/icons/streamline-light';
import { defineKey } from '@ha/intl';
import { LinkItemType } from './types';

export const NOFOLLOW_REF = 'nofollow noopener noreferrer';

export const socialLinksData = [
  {
    socialVendor: 'facebook',
    urlBuilder: 'getFacebookUrl',
    icon: <SocialMediaFacebook />,
  },
  {
    socialVendor: 'twitter',
    urlBuilder: 'getTwitterUrl',
    icon: <SocialMediaTwitter />,
  },
  {
    socialVendor: 'linkedin',
    urlBuilder: 'getLinkedinUrl',
    icon: <ProfessionalNetworkLinkedin />,
  },
  {
    socialVendor: 'youtube',
    urlBuilder: 'getYoutubeUrl',
    icon: <SocialVideoYoutube />,
  },
  {
    socialVendor: 'instagram',
    urlBuilder: 'getInstagramUrl',
    icon: <SocialMediaInstagram sx={{ fill: 'none' }} />,
  },
];

export const housingAnywhereColumnData: LinkItemType[] = [
  {
    name: 'About',
    urlBuilder: 'getAboutUrl',
    label: defineKey('footer.about_ha'),
  },
  {
    name: 'Careers',
    urlBuilder: 'getCareersUrl',
    label: defineKey('Careers'),
  },
  {
    name: 'Press releases',
    urlBuilder: 'getPressUrl',
    label: defineKey('Press'),
  },
  {
    name: 'Become a partner plans',
    urlBuilder: 'getPartnershipsUrl',
    label: defineKey('Become a partner'),
    noFollow: NOFOLLOW_REF,
  },
  {
    name: 'Terms and conditions',
    urlBuilder: 'getTermsUrl',
    label: defineKey('terms_header'),
    noFollow: NOFOLLOW_REF,
  },
  {
    name: 'Privacy Policy',
    urlBuilder: 'getPrivacyPolicyUrl',
    label: defineKey('privacy_policy_header'),
    noFollow: NOFOLLOW_REF,
  },
  {
    name: 'Cookie Policy',
    urlBuilder: 'getCookiePolicyUrl',
    label: defineKey('cookie_policy_header'),
    noFollow: NOFOLLOW_REF,
  },
  {
    name: 'Sitemap',
    urlBuilder: 'getSitemapUrl',
    label: defineKey('Sitemap'),
    noFollow: NOFOLLOW_REF,
  },
];

export const tenantsColumnData: LinkItemType[] = [
  {
    name: 'How to rent',
    urlBuilder: 'getRenting',
    label: defineKey('How to rent'),
  },
  {
    name: 'Pricing tenants',
    urlBuilder: 'getPricingTenantsUrl',
    label: defineKey('Pricing'),
  },
];

export const supportColumnData: LinkItemType[] = [
  {
    name: 'FAQ',
    urlBuilder: 'getAnswersUrl',
    label: defineKey('faq_short'),
  },
  {
    name: 'Contact us',
    urlBuilder: 'getContactUrl',
    label: defineKey('contact_us_header'),
  },
];
